<!--page starts-->
<section class="page-wrapper">
    <div class="register-hero-section margin-top-152 cf">
        <div class="container">
           <div class="register-hero-detail">
               <div class="register-hero-top">
                    <div class="register-titel">
                       <h2>Add Address<span><img src="assets/images/ic-logo-new.png"></span></h2>
                    </div>
               </div>
               <div class="register-hero-bottom cf">
                   <div class="register-hero-detail">
                        <div class="register-input-box half mr">
                           <input type="text" placeholder="LINE 1">
                        </div>
                        <div class="register-input-box half">
                            <input type="text" placeholder="LINE 2">
                        </div>
                        <div class="register-input-box half mr">
                            <input type="text" placeholder="City">
                        </div>
                        <div class="register-input-box half">
                            <input type="text" placeholder="State">
                        </div>
                        <div class="register-input-box half mr">
                            <input type="text" placeholder="Country">
                        </div>
                        <div class="register-input-box half">
                            <input type="number" placeholder="Post code">
                        </div>
                        <div class="register-btn">
                            <button>SUBMIT</button>
                        </div>
                        <div class="register-back-to">
                            <a href="javascript:void(0)">Back to Login</a>
                        </div>
                   </div>
               </div>
           </div>
        </div>
    </div>
</section><!-- page ends-->